import { createFileRoute } from "@tanstack/react-router";
import NoticeLookup from "@/pages/site/NoticeLookup";

export const Route = createFileRoute("/resources/notice-lookup")({
  component: () => <NoticeLookup />,
});
